module.exports = __webpack_public_path__ + "img/f42.02033012.jpg";